import {Component, EventEmitter, Input, Output} from '@angular/core';
import {filter as loFilter} from "lodash-es";
import {Category} from "@app/feature/reward/models/Reward";

class Selectable{
  selected?:boolean
}

@Component({
  selector: 'app-reward-category-filter',
  templateUrl: './reward-category-filter.component.html',
  styleUrls: ['./reward-category-filter.component.scss']
})
export class RewardCategoryFilterComponent<T>{
  constructor() { }

  public categoryList:Category[]
  public checkedID:number
  public isMobileVisible:boolean = false
  private _dataSource:T[]

  @Input()
  set dataSource(data:T[]){
    this._dataSource = data
    let filtered = this.filterByCategory(this.categories, data)
    this.onFilter.emit(filtered)
  }

  @Input()
  set categories(categories: Category[]){ this.categoryList = categories }

  @Output()
  public onFilter:EventEmitter<T[]> = new EventEmitter<T[]>()

  private filterByCategory<T>(categories:Category[]=[], source:T[]): T[]{
    let selectedCategoryIDS = categories
      .filter((R:Category)=>R.selected)
      .map((R:Category)=>R.id)

    return (
      selectedCategoryIDS.length > 0
        ? loFilter(
            source,
            (r:any)=>r.category && selectedCategoryIDS.includes(r.category.id)
          )
        : source
    ) as T[]
  }

  public check(category:Category, checked:boolean){
    category.selected = checked

    this.checkedID = checked
      ? this.checkedID = category.id
      : undefined

    let dataSourceFiltered = this.filterByCategory([category], this._dataSource)

    this.onFilter.emit(dataSourceFiltered)
  }

  public toggleFilter(){
    this.isMobileVisible = !this.isMobileVisible
  }

}
